/* eslint-disable */
<template>
  <div class="login-page">
    <div class="login-container">

      <!-- Left: Branding Panel -->
      <div class="branding-panel">
        <div class="branding-content">
          <div class="brand-gov-badge">LG</div>
          <h1 class="brand-title">Welcome Back</h1>
          <p class="brand-subtitle">Sign in to access your local government online payment services</p>
          <p class="brand-sinhala">පළාත් පාලන මාර්ගගත ගෙවීම් සේවාවට ඔබව සාදරයෙන් පිළිගනිමු</p>

          <div class="features-list">
            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Secure Payments</strong>
                <span>Bank-grade security for all transactions</span>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>24/7 Access</strong>
                <span>Pay anytime, anywhere</span>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Instant Receipts</strong>
                <span>Download payment proof immediately</span>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                </svg>
              </div>
              <div class="feature-text">
                <strong>Multiple Services</strong>
                <span>Shop rent, taxes, bookings &amp; more</span>
              </div>
            </div>
          </div>
        </div>

        <div class="branding-footer">
          <p>Ministry of Public Administration, Home Affairs,<br>Provincial Councils &amp; Local Government</p>
        </div>
      </div>

      <!-- Right: Form Panel -->
      <div class="form-panel">
        <div class="form-inner">

          <!-- Form Header -->
          <div class="form-header">
            <div class="form-header-bar"></div>
            <div>
              <p class="form-breadcrumb">Local Government Payment System</p>
              <h2 class="form-title">{{ otpStep ? 'Verify OTP' : 'Sign In' }}</h2>
              <p class="form-subtitle">
                {{ otpStep
                  ? `Code sent to ${phoneMasked} | කේතය යවා ඇත`
                  : 'ඔබගේ ගිණුමට පිවිසෙන්න | Enter your NIC below' }}
              </p>
            </div>
          </div>

          <!-- Error Alert -->
          <transition name="slide-fade">
            <div v-if="errors.length" class="error-alert">
              <div class="error-alert-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
              </div>
              <ul class="error-list">
                <li v-for="error in errors" :key="error">{{ error }}</li>
              </ul>
            </div>
          </transition>

          <!-- ── STEP 1: NIC Form ── -->
          <form v-if="!otpStep" @submit="handleSubmit" novalidate autocomplete="off">

            <!-- Province -->
            <div class="field-group">
              <label class="field-label" for="province">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                Province | පළාත <span class="req">*</span>
              </label>
              <div class="input-wrap">
                <select @change="updateBackendUrl" v-model="loginObj.pro" id="province"
                  class="field-input select-input" :class="{ filled: loginObj.pro }">
                  <option value="" disabled>Choose Province | පළාත තෝරන්න</option>
                  <option v-for="f in province" :key="f.pro_id" :value="f.pro_code">{{ f.pro_name }}</option>
                </select>
                <div class="select-chevron">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                  </svg>
                </div>
              </div>
            </div>

            <!-- NIC -->
            <div class="field-group">
              <label class="field-label" for="uNIC">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"/>
                </svg>
                NIC Number | හැඳුනුම්පත් අංකය <span class="req">*</span>
              </label>
              <div class="input-wrap">
                <input type="text" id="uNIC" class="field-input" placeholder="Enter your NIC"
                  v-model="loginObj.nic" :class="{ filled: loginObj.nic }" />
                <div class="input-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Submit -->
            <button type="submit" class="submit-btn" :disabled="isLoading">
              <span v-if="!isLoading" class="btn-inner">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2v-1a4 4 0 00-4-4H8a4 4 0 00-4 4v1a2 2 0 002 2zM12 11a4 4 0 100-8 4 4 0 000 8z"/>
                </svg>
                Send OTP | කේතය යවන්න
              </span>
              <span v-else class="btn-inner">
                <svg class="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="spinner-track"></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" class="spinner-fill"></path>
                </svg>
                Sending...
              </span>
            </button>

          </form>

          <!-- ── STEP 2: OTP Form ── -->
          <div v-else>

            <!-- OTP info banner -->
            <div class="otp-banner">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2v-1a4 4 0 00-4-4H8a4 4 0 00-4 4v1a2 2 0 002 2zM12 11a4 4 0 100-8 4 4 0 000 8z"/>
              </svg>
              <span>6-digit OTP sent to <strong>{{ phoneMasked }}</strong>. Valid for 5 minutes.</span>
            </div>

            <!-- OTP boxes -->
            <div class="field-group">
              <label class="field-label">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                </svg>
                Enter OTP | OTP කේතය <span class="req">*</span>
              </label>
              <div class="otp-inputs">
                <input
                  v-for="(_, i) in otp" :key="i"
                  :ref="el => { if (el) otpRefs[i] = el }"
                  maxlength="1"
                  inputmode="numeric"
                  pattern="[0-9]"
                  class="otp-box"
                  :class="{ filled: otp[i] }"
                  v-model="otp[i]"
                  @input="onOtpInput(i, $event)"
                  @keydown.backspace="onOtpBackspace(i)"
                  @paste.prevent="onOtpPaste($event)"
                />
              </div>
            </div>

            <!-- Verify button -->
            <button class="submit-btn" :disabled="isLoading || otp.join('').length < 6" @click="verifyOtp">
              <span v-if="!isLoading" class="btn-inner">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Confirm & Login | තහවුරු කරන්න
              </span>
              <span v-else class="btn-inner">
                <svg class="spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" class="spinner-track"></circle>
                  <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" class="spinner-fill"></path>
                </svg>
                Verifying...
              </span>
            </button>

            <!-- Resend + Back -->
            <div class="otp-actions">
              <button type="button" class="resend-btn" :disabled="resendCooldown > 0" @click="resendOtp">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                </svg>
                {{ resendCooldown > 0 ? `Resend in ${resendCooldown}s` : 'Resend OTP' }}
              </button>
              <button type="button" class="back-btn" @click="goBack">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
                </svg>
                Change NIC
              </button>
            </div>

          </div>

          <!-- Register + Help -->
          <div class="form-bottom">
            <p class="register-hint">
              Don't have an account? | නව ගිණුමක් සඳහා
              <router-link @click="scrollToTop()" to="/register" class="register-link">Create One</router-link>
            </p>
            <div class="divider"><span>Need Help?</span></div>
            <div class="help-links">
              <a href="#" class="help-link">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                Contact Support
              </a>
              <a href="#" class="help-link">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
                Help Centre
              </a>
            </div>
          </div>

          <div class="panel-footer">
            <p>&copy; {{ new Date().getFullYear() }} Local Government Payment System. All rights reserved.</p>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapMutations } from "vuex";
axios.defaults.withCredentials = true;
export default {
  name: 'Login',
  data() {
    return {
      loginObj: { pro: "", nic: "" },
      errors: [],
      province: [],
      isLoading: false,
      // OTP step
      otpStep: false,
      otp: ["", "", "", "", "", ""],
      otpRefs: [],
      phoneMasked: "",
      resendCooldown: 0,
      resendTimer: null,
    };
  },
  created() {
    this.Allprovince();
    
  },
  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    addZero(num) {
      num = num.toString();
      return '19' + num.slice(0, 5) + '0' + num.slice(5, -1);
    },

    addZeroPadding() {
      if (!isNaN(parseInt(this.loginObj.nic)) && this.loginObj.nic !== null &&
        (this.loginObj.nic.charAt(9).toUpperCase() === 'V' || this.loginObj.nic.charAt(9).toUpperCase() === 'X')) {
        return this.addZero(this.loginObj.nic);
      }
      return this.loginObj.nic;
    },

    async Allprovince() {
      this.province = (await axios.get('/allprovinces/')).data;
    },

    updateBackendUrl() {
      // const url = this.loginObj.pro === 'PRO1'
      //   ? "http://" + window.location.hostname + ":4000/api"
      //   : "http://" + window.location.hostname + ":3000/api";
      const url = this.loginObj.pro === 'PRO1'
        ? "https://elgservices.com.lk/acc"
        : "https://elgservices.com.lk/api";

      //   const url = this.loginObj.pro === 'PRO1'
      //   ? "https://elgservices.lk/newacc"
      //   : "https://elgservices.lk/api";
      
      axios.defaults.baseURL = url;

      
    },

    // ── Step 1: send OTP ──
    async handleSubmit(e) {
      e.preventDefault();
      this.errors = [];

      if (!this.loginObj.pro) this.errors.push("Please select a province");
      if (!this.loginObj.nic) {
        this.errors.push("NIC is required");
      } else if (
        this.loginObj.nic.length !== 12 &&
        !(this.loginObj.nic.charAt(9).toUpperCase() === 'V' ||
          this.loginObj.nic.charAt(9).toUpperCase() === 'X')
      ) {
        this.errors.push("Please enter a valid NIC number");
      }
      if (this.errors.length) return;

      this.isLoading = true;
      try {
        const res = await axios.post("/send-otp", {
          nic: this.addZeroPadding(),
          sabha_code: this.loginObj.pro,
        });
        this.phoneMasked = res.data.phone_masked;
        this.otpStep = true;
        this.startResendCooldown();
        this.$nextTick(() => this.otpRefs[0]?.focus());

        
      } catch (err) {
        const code = err.response?.data?.error;
        const messages = {
          not_found:          "NIC not registered. Please check and try again.",
          no_phone:           "No mobile number linked to this account. Contact your local office.",
          sms_not_configured: "SMS service unavailable for this province.",
          sms_failed:         "Failed to send OTP. Please try again.",
        };
        this.errors.push(messages[code] || "Something went wrong. Please try again.");
      } finally {
        this.isLoading = false;
      }
    },

    // ── Step 2: verify OTP ──
    async verifyOtp() {
      this.errors = [];
      const code = this.otp.join("");
      if (code.length < 6) {
        this.errors.push("Please enter the complete 6-digit OTP.");
        return;
      }

      this.isLoading = true;
      try {
        const res = await axios.post("/verify-otp", {
          nic: this.addZeroPadding(),
          otp: code,
        });

        // const backendUrl = this.loginObj.pro === "PRO1"
        //   ? "http://" + window.location.hostname + ":4000/api"
        //   : "http://" + window.location.hostname + ":3000/api";

                const backendUrl = this.loginObj.pro === "PRO1"
          ? "https://elgservices.com.lk/acc"
          : "https://elgservices.com.lk/api";

          //       const backendUrl = this.loginObj.pro === "PRO1"
          // ? "https://elgservices.lk/newacc"
          // : "https://elgservices.lk/api";
        
            const user = res.data.user;

            this.setUser(user);

            // Save token
            sessionStorage.setItem("token", res.data.token);
            localStorage.setItem("token", res.data.token);

            // Save user
            sessionStorage.setItem("user", JSON.stringify(user));
            localStorage.setItem("user", JSON.stringify(user));

            const data = {
              Unic: user.cus_nic,
              Uname: user.cus_name,
              Upro: this.loginObj.pro,
              Usabha: user.sabha,
            };

           console.log("Saving Userdata:", data);

          sessionStorage.setItem("Userdata", JSON.stringify(data));
          localStorage.setItem("Userdata", JSON.stringify(data));

          console.log("Session Userdata:", sessionStorage.getItem("Userdata"));
          console.log("Local Userdata:", localStorage.getItem("Userdata"));
              window.sessionStorage.setItem("backendUrl", backendUrl);
        axios.defaults.baseURL = backendUrl;
console.log("Login URL:", backendUrl);
        await axios.post("/onlinelogin", { login_nic: user.cus_nic });
            setTimeout(() => {
              this.$router.push("/home");
            }, 500);
                    
        // await axios.post("/onlinelogin", { login_nic: user.cus_nic });


      } catch (err) {
        const code = err.response?.data?.error;
        const messages = {
          no_otp:   "No OTP found. Please request a new one.",
          expired:  "OTP has expired. Please request a new one.",
          invalid:  "Incorrect OTP. Please try again.",
        };
        this.errors.push(messages[code] || "Verification failed. Please try again.");
        this.otp = ["", "", "", "", "", ""];
        this.$nextTick(() => this.otpRefs[0]?.focus());
      } finally {
        this.isLoading = false;
      }
    },

    // ── OTP input handlers ──
    onOtpInput(i, e) {
      const val = e.target.value.replace(/\D/g, "");
      this.otp[i] = val;
      e.target.value = val;
      if (val && i < 5) this.otpRefs[i + 1]?.focus();
    },

    onOtpBackspace(i) {
      if (!this.otp[i] && i > 0) {
        this.otp[i - 1] = "";
        this.otpRefs[i - 1]?.focus();
      }
    },

    onOtpPaste(e) {
      const text = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
      text.split("").forEach((ch, i) => { this.otp[i] = ch; });
      this.$nextTick(() => this.otpRefs[Math.min(text.length, 5)]?.focus());
    },

    // ── Resend ──
    async resendOtp() {
      if (this.resendCooldown > 0) return;
      this.otp = ["", "", "", "", "", ""];
      this.errors = [];
      await this.handleSubmit({ preventDefault: () => {} });
    },

    startResendCooldown() {
      this.resendCooldown = 60;
      clearInterval(this.resendTimer);
      this.resendTimer = setInterval(() => {
        if (--this.resendCooldown <= 0) clearInterval(this.resendTimer);
      }, 1000);
    },

    goBack() {
      this.otpStep = false;
      this.otp = ["", "", "", "", "", ""];
      this.errors = [];
      clearInterval(this.resendTimer);
      this.resendCooldown = 0;
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; margin: 0; padding: 0; }

.login-page {
  min-height: 82vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  display: flex; align-items: center; justify-content: center;
  padding: 0.8rem 1.5rem;
}

.login-container {
  display: grid;
  grid-template-columns: 42% 58%;
  width: 100%; max-width: 1050px;
  background: #fff;
  border-radius: 1.4rem; overflow: hidden;
  box-shadow: 0 8px 40px rgba(100,50,30,0.12);
  border: 1px solid #e5ddd5;
}

/* ── Branding ── */
.branding-panel {
  background: linear-gradient(160deg, #7c2d12 0%, #9a3412 50%, #c2440a 100%);
  padding: 2rem 2.2rem;
  display: flex; flex-direction: column; justify-content: space-between;
  position: relative; overflow: hidden;
}
.branding-panel::before {
  content: ''; position: absolute; top: -20%; right: -30%;
  width: 38rem; height: 38rem; border-radius: 50%;
  background: rgba(255,255,255,0.05); pointer-events: none;
}
.branding-panel::after {
  content: ''; position: absolute; bottom: -15%; left: -20%;
  width: 28rem; height: 28rem; border-radius: 50%;
  background: rgba(0,0,0,0.07); pointer-events: none;
}
.branding-content { position: relative; z-index: 1; }
.brand-gov-badge {
  width: 4rem; height: 4rem; border-radius: 0.8rem;
  background: rgba(255,255,255,0.15); border: 2px solid rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
  font-family: 'DM Serif Display', serif; font-size: 1.5rem; font-weight: 700; color: #fff;
  margin-bottom: 1rem;
}
.brand-title { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #fff; line-height: 1.2; margin-bottom: 0.4rem; }
.brand-subtitle { font-size: 1.15rem; color: rgba(255,255,255,0.85); margin-bottom: 0.3rem; line-height: 1.5; }
.brand-sinhala  { font-size: 1rem; color: rgba(255,255,255,0.65); margin-bottom: 1.2rem; line-height: 1.5; }
.features-list { display: flex; flex-direction: column; gap: 0.6rem; }
.feature-item {
  display: flex; align-items: flex-start; gap: 0.8rem;
  padding: 0.7rem 0.9rem;
  background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.14);
  border-radius: 0.7rem; transition: all 0.2s;
}
.feature-item:hover { background: rgba(255,255,255,0.14); transform: translateX(4px); }
.feature-icon { width: 1.8rem; height: 1.8rem; flex-shrink: 0; }
.feature-icon svg { width: 100%; height: 100%; stroke: rgba(255,255,255,0.9); }
.feature-text { display: flex; flex-direction: column; gap: 0.05rem; }
.feature-text strong { font-size: 1.15rem; font-weight: 600; color: #fff; }
.feature-text span   { font-size: 1rem; color: rgba(255,255,255,0.72); }
.branding-footer {
  position: relative; z-index: 1;
  border-top: 1px solid rgba(255,255,255,0.15);
  padding-top: 0.9rem; margin-top: 0.9rem;
}
.branding-footer p { font-size: 1rem; color: rgba(255,255,255,0.6); line-height: 1.5; }

/* ── Form Panel ── */
.form-panel { padding: 1.8rem 2.6rem; display: flex; flex-direction: column; }
.form-inner  { display: flex; flex-direction: column; flex: 1; }

.form-header { display: flex; align-items: flex-start; gap: 1rem; margin-bottom: 1.4rem; }
.form-header-bar {
  width: 4px; min-height: 52px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 3px;
}
.form-breadcrumb { font-size: 1rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.15rem; }
.form-title    { font-family: 'DM Serif Display', serif; font-size: 2rem; color: #1c0f0a; margin: 0 0 0.15rem; }
.form-subtitle { font-size: 1.15rem; color: #9a8070; margin: 0; line-height: 1.5; }

/* ── Error ── */
.error-alert {
  display: flex; align-items: flex-start; gap: 0.8rem;
  background: #fef2f2; border: 1px solid #fecaca;
  border-left: 4px solid #dc2626; border-radius: 0; 
  border-radius: 0.8rem; padding: 0.9rem 1.2rem; margin-bottom: 1.2rem;
}
.error-alert-icon { width: 1.8rem; height: 1.8rem; flex-shrink: 0; color: #dc2626; }
.error-alert-icon svg { width: 100%; height: 100%; }
.error-list { list-style: none; margin: 0; padding: 0; flex: 1; }
.error-list li { font-size: 1.25rem; color: #b91c1c; padding: 0.1rem 0; }

/* ── Fields ── */
.field-group { margin-bottom: 1.1rem; }
.field-label {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 1.2rem; font-weight: 600; color: #4a3028; margin-bottom: 0.45rem;
}
.field-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.req { color: #c2440a; }
.input-wrap { position: relative; }
.field-input {
  width: 100%; padding: 0.65rem 1rem 0.65rem 3.1rem;
  font-size: 1.3rem; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: 0.7rem;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.field-input:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09); }
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input::placeholder { color: #b0a09a; }
.input-icon {
  position: absolute; left: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.5rem; height: 1.5rem; color: #9a8070; pointer-events: none;
}
.input-icon svg { width: 100%; height: 100%; }
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 2.8rem; }
.select-chevron {
  position: absolute; right: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.4rem; height: 1.4rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }

/* ── OTP banner ── */
.otp-banner {
  display: flex; align-items: center; gap: 0.7rem;
  background: #f0fdf4; border: 1px solid #bbf7d0;
  border-left: 4px solid #16a34a; border-radius: 0;
  border-radius: 0.8rem; padding: 0.8rem 1rem; margin-bottom: 1.2rem;
  font-size: 1.15rem; color: #15803d;
}
.otp-banner svg { width: 1.4rem; height: 1.4rem; stroke: #16a34a; flex-shrink: 0; }
.otp-banner strong { color: #14532d; }

/* ── OTP inputs ── */
.otp-inputs { display: flex; gap: 0.6rem; }
.otp-box {
  flex: 1; text-align: center;
  font-size: 1.8rem; font-weight: 700; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: 0.7rem;
  padding: 0.7rem 0;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  min-width: 0;
}
.otp-box:focus { outline: none; border-color: #c2440a; background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09); }
.otp-box.filled { background: #fff; border-color: #c2440a; }

/* ── Submit ── */
.submit-btn {
  width: 100%; padding: 0.85rem 2rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28); transition: all 0.2s;
}
.submit-btn:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }
.submit-btn:disabled { opacity: 0.65; cursor: not-allowed; }
.btn-inner { display: flex; align-items: center; justify-content: center; gap: 0.7rem; }
.btn-inner svg { width: 1.8rem; height: 1.8rem; }

/* Spinner */
.spinner { width: 1.8rem; height: 1.8rem; animation: spin 1s linear infinite; }
.spinner-track { opacity: 0.25; }
.spinner-fill  { opacity: 0.75; }
@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }

/* ── OTP actions ── */
.otp-actions { display: flex; justify-content: space-between; align-items: center; margin-top: 1rem; }

.resend-btn, .back-btn {
  display: inline-flex; align-items: center; gap: 0.4rem;
  background: none; border: none; cursor: pointer;
  font-family: 'DM Sans', sans-serif; font-size: 1.15rem; font-weight: 500;
  transition: color 0.2s; padding: 0;
}
.resend-btn { color: #c2440a; }
.resend-btn:disabled { color: #9a8070; cursor: not-allowed; }
.resend-btn:not(:disabled):hover { color: #7c2d12; }
.resend-btn svg, .back-btn svg { width: 1.2rem; height: 1.2rem; }
.back-btn { color: #7a6258; }
.back-btn:hover { color: #1c0f0a; }

/* ── Bottom ── */
.form-bottom { margin-top: 1.2rem; }
.register-hint { font-size: 1.25rem; color: #7a6258; text-align: center; margin: 0 0 1rem; }
.register-link { color: #c2440a; font-weight: 600; text-decoration: none; }
.register-link:hover { text-decoration: underline; }
.divider {
  display: flex; align-items: center; gap: 1rem;
  font-size: 1.15rem; color: #9a8070; margin-bottom: 1rem;
}
.divider::before, .divider::after { content: ''; flex: 1; height: 1px; background: #e5ddd5; }
.help-links { display: flex; justify-content: center; gap: 2rem; flex-wrap: wrap; }
.help-link {
  display: inline-flex; align-items: center; gap: 0.5rem;
  font-size: 1.2rem; color: #7a6258; text-decoration: none; transition: color 0.2s;
}
.help-link svg { width: 1.4rem; height: 1.4rem; }
.help-link:hover { color: #c2440a; }
.panel-footer { margin-top: 1rem; padding-top: 0.9rem; border-top: 1px solid #f0ebe3; text-align: center; }
.panel-footer p { font-size: 1.05rem; color: #9a8070; }

/* ── Animations ── */
.slide-fade-enter-active, .slide-fade-leave-active { transition: all 0.3s ease; }
.slide-fade-enter-from, .slide-fade-leave-to { transform: translateY(-8px); opacity: 0; }

/* ── Responsive ── */
@media (max-width: 900px) {
  .login-container { grid-template-columns: 1fr; max-width: 520px; }
  .branding-panel  { display: none; }
  .form-panel      { padding: 2rem 2rem; }
}
@media (max-width: 520px) {
  .login-page  { padding: 0.5rem; }
  .form-panel  { padding: 1.5rem 1.2rem; }
  .form-title  { font-size: 1.8rem; }
  .otp-inputs  { gap: 0.4rem; }
  .otp-box     { font-size: 1.5rem; padding: 0.6rem 0; }
  .help-links  { flex-direction: column; align-items: center; gap: 1rem; }
}
</style>